export class UnsecureViewDocumentsConstants {
    static COMPONENT_TYPE = "Public View Documents";
    static TITLE = "View Documents";
    static COMMENT_STATUS_CLOSED = "Closed";
    static CAPTURE_NOT_ALLOWED = "Request for comment has expired";
    static NO_ITEMS_MESSAGE = "No attachments found";
    static NO_REQUESTID_MESSAGE = "No valid request Id provided";
    static FIRST_OPEN_MESSAGE = "The link to this page is set to expire once this window has been closed";
}
